module.exports = __webpack_public_path__ + "static/media/64.90d446ab.jpg";